<template>

<div class="notes">

	<com-headmain :simple="true" />

	<div class="notes-content">

		<div class="notes-title">{{ section.patient.title || section.text.title }}<div class="subsection-close" v-on:click="$emit('back')"></div></div>

		<div class="notes-intro" v-if="section.intro" v-html="section.intro"></div>

		<textarea class="notes-textarea" v-model="notes" :placeholder="section.placeholder || 'Use this section to jot down any thoughts you have or questions that you would like to ask your healthcare professional...'"></textarea>

		<div class="notes-saved" v-if="saved">
			<i class="fa-solid fa-check"></i> Your notes have been saved
		</div>

		<com-check :text="section.text.title" v-on:click="$emit('next')" />

	</div>

</div>

</template>

<script>

import comHeadMain from './../../common/Head'
import comCheck from './common/Check'

export default {

	props: ['section'],

	components: {
		'com-headmain': comHeadMain,
		'com-check': comCheck
	},

	data: function() {

		return {
			notes: '',
			saved: false,
			saveTimer: null
		}

	},

	created: function() {

		this.notes = this.$cookies.getItem('ifrap_patient_notes') || ''

	},

	watch: {

		notes: function(val) {

			clearTimeout(this.saveTimer)

			this.saveTimer = setTimeout(function() {
				this.$cookies.setItem('ifrap_patient_notes', val)
				this.saved = true
				setTimeout(function() { this.saved = false }.bind(this), 2000)
			}.bind(this), 500)

		}

	}

}

</script>

<style scoped>

.notes {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

.is-tablet .notes { left: 64px; }
.is-mobile .notes { left: 0px; }

.notes-content {
	width: 100%;
	max-width: 800px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-mobile .notes-content { padding: 80px 15px 85px 15px; }

.notes-title {
	font-weight: 100;
	font-size: 36px;
	line-height: 36px;
	letter-spacing: 3px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 48px;
}

.notes-title:after { content: ' '; position: absolute; bottom: -16px; left: 0px; height: 4px; background-color: var(--aid-color); width: 150px; }

.is-mobile .notes-title { font-size: 18px; line-height: 18px; margin-bottom: 32px; }

.notes-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 32px; }
.is-mobile .notes-intro { font-size: 14px; line-height: 22px; }

.notes-textarea {
	width: 100%;
	min-height: 300px;
	padding: 24px;
	font-size: 16px;
	line-height: 26px;
	color: #343434;
	border: 2px solid #e0e0e0;
	border-radius: 16px;
	resize: vertical;
	outline: none;
	font-family: inherit;
	transition: border-color 300ms ease-in-out;
	margin-bottom: 16px;
}

.notes-textarea:focus { border-color: var(--aid-color); }

.is-mobile .notes-textarea { min-height: 200px; font-size: 14px; padding: 16px; }

.notes-saved {
	font-size: 14px;
	color: #4CAF50;
	font-weight: 600;
	margin-bottom: 16px;
}

.notes-saved i { margin-right: 6px; }

</style>
